import {PlayerData_Transport} from "../dto/com.rico.sb2.service.positions";
import {UpdateTransportMessage} from "../dto/com.rico.sb2.message";
import {Badge, ProcessControlService_Mode} from "../dto/com.rico.sb2.service";
import {TransportAction, TransportStateFlag} from "../dto/com.rico.sb2.entity.device";
import {coalesce} from "../lib/coalesce";

export interface TransportDataSupplier {
	get data(): PlayerData_Transport

	get update(): UpdateTransportMessage | null

	get serviceMode(): ProcessControlService_Mode | null

	getPositionTitle(pos: number | null): string

	getPositionCode(pos: number | null): string

	findContainerOnTransport(): number | null

	findContainerOnPosition(position: number): number | null

	get badges(): Badge[]
}

export class TransportDataAdapter {
	private readonly supplier: TransportDataSupplier;

	constructor(supplier: TransportDataSupplier) {
		this.supplier = supplier
	}

	get serviceMode() {
		return this.supplier.serviceMode;
	}

	get type() {
		return this.supplier.data.type;
	}

	get number() {
		return this.supplier.data.number;
	}

	get code() {
		return this.supplier.data.code;
	}

	get action(): TransportAction | null {
		const update = this.supplier.update;
		return update ? update.action : TransportAction.STOPPED;
	}

	get enabled() {
		return this.state == TransportStateFlag.ENABLED;
	}

	get state(): TransportStateFlag {
		const update = this.supplier.update;
		return coalesce(update?.state, this.supplier.data.state);
	}

	get position() {
		const update = this.supplier.update;
		if (update != null) {
			return update.position;
		}
		return this.supplier.data.position ?? this.supplier.data.min;
	}

	get positionCode() {
		return this.supplier.getPositionCode(this.position);
	}

	get positionTitle() {
		return this.supplier.getPositionTitle(this.position);
	}

	get container(): number | null {
		return this.supplier.findContainerOnTransport();
	}

	get containerBelow(): number | null {
		const position = this.position;
		if (position == null) return null;
		return this.supplier.findContainerOnPosition(position);
	}

	get badges(): Badge[] {
		return this.supplier.badges;
	}
}